// import React from 'react';
// import { Routes, Route, Navigate } from 'react-router-dom';
// import AdminDashboard from './pages/Admin/Dashboard';
// import OutsourceRoles from './pages/Admin/OutsourceRoles';
// import ServicePrices from './pages/Admin/ServicePrices';
// import ArtistDashboard from './pages/Artist/Dashboard';
// import Navbar from './components/Navbar';

// function App() {
//   return (
//     <div className="min-h-screen bg-gray-50">
//       <Navbar />
//       <Routes>
//         <Route path="/" element={<Navigate to="/about" />} />
//         <Route path="/about" element={<AboutUs />} />
//         <Route path="/login" element={<LoginRedirect />} />
//         <Route path="/register" element={<Register />} />
//         <Route path="/admin/dashboard" element={<AdminDashboard />} />
//         <Route path="/admin/outsource-roles" element={<OutsourceRoles />} />
//         <Route path="/admin/service-prices" element={<ServicePrices />} />
//         <Route path="/admin/outsource-persons" element={<OutsourcePersons />} />
//         <Route path="/artist/dashboard" element={<ArtistDashboard />} />
//         <Route path="/artist/bookings" element={<ArtistBookings />} />
//         <Route path="/artist/outsource-persons" element={<ArtistOutsourcePersons />} />
//         <Route path="/artist/service-prices" element={<ServicePricesArtist />} />
//         <Route path="/artist/add-booking" element={<AddBooking />} />
//       </Routes>
//     </div>
//   );
// }

// export default App;

import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import LoginRedirect from "./pages/LoginRedirect";
import Register from "./pages/Auth/Register";
import ArtistSignup from "./pages/Auth/ArtistSignup";
import PlanSelection from "./pages/Auth/PlanSelection";
import SignupSuccess from "./pages/Auth/SignupSuccess";
import ForceChangePassword from "./pages/Auth/ForceChangePassword";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import ProtectedRoute from "./routes/ProtectedRoute";
// Admin pages
import AdminDashboard from "./pages/Admin/Dashboard";
import OutsourceRoles from "./pages/Admin/OutsourceRoles";
import ServicePricesAdmin from "./pages/Admin/ServicePrices";
import Services from "./pages/Admin/Services";
import MakeupArtists from "./pages/Admin/MakeupArtists";
import Users from "./pages/Admin/Users";
import EmailTemplatesPage from "./pages/Admin/EmailTemplatesPage";
import EmailSendersPage from "./pages/Admin/EmailSendersPage";
import EmailMappingsPage from "./pages/Admin/EmailMappingsPage";
import AdminPlansPage from "./pages/Admin/AdminPlansPage";
import AdminArtistSubscriptionsPage from "./pages/Admin/AdminArtistSubscriptionsPage";
import ArtistTypesPage from "./pages/Admin/ArtistTypesPage";
// Artist pages
import ArtistDashboard from "./pages/Artist/Dashboard";
import ArtistBookings from "./pages/Artist/ArtistBookings";
import BookingReports from "./pages/Artist/BookingReports";
import ArtistOutsourcePersons from "./pages/Artist/OutsourcePersons";
import ServicePricesArtist from "./pages/Artist/ArtistServicePrices";
import AddBooking from "./pages/Artist/AddBooking";
import SubscriptionExpired from "./pages/Artist/SubscriptionExpired";
import UpdateBanner from "./components/UpdateBanner";
// Development only: ApiHealthCheck will be lazy-loaded to avoid bundling in production

function App() {
  return (
    <AuthProvider>
      <Navbar />
      <UpdateBanner />
  <Routes>
  <Route path="/admin/artist-types" element={<ProtectedRoute roles={["Admin"]}><ArtistTypesPage /></ProtectedRoute>} />
        {/* Development-only route for API health check (lazy-loaded) */}
        {(() => {
          if (process.env.NODE_ENV === 'development') {
            const DevApiHealth = lazy(() => import('./pages/ApiHealthCheck'));
            return (
              <Route
                path="/api-health"
                element={
                  <Suspense fallback={null}>
                    <DevApiHealth />
                  </Suspense>
                }
              />
            );
          }
          return null;
        })()}
        
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute roles={["Admin"]}>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/outsource-roles"
          element={
            <ProtectedRoute roles={["Admin"]}>
              <OutsourceRoles />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/services"
          element={
            <ProtectedRoute roles={["Admin"]}>
              <Services />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/service-prices"
          element={
            <ProtectedRoute roles={["Admin"]}>
              <ServicePricesAdmin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/makeup-artists"
          element={
            <ProtectedRoute roles={["Admin"]}>
              <MakeupArtists />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute roles={["Admin"]}>
              <Users />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/email-templates"
          element={
            <ProtectedRoute roles={["Admin"]}>
              <EmailTemplatesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/email-senders"
          element={
            <ProtectedRoute roles={["Admin"]}>
              <EmailSendersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/email-mappings"
          element={
            <ProtectedRoute roles={["Admin"]}>
              <EmailMappingsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/plans"
          element={
            <ProtectedRoute roles={["Admin"]}>
              <AdminPlansPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/artist-subscriptions"
          element={
            <ProtectedRoute roles={["Admin"]}>
              <AdminArtistSubscriptionsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/artist/dashboard"
          element={
            <ProtectedRoute roles={["Artist"]}>
              <ArtistDashboard />
            </ProtectedRoute>
          }
        />    
        <Route
          path="/artist/bookings"
          element={
            <ProtectedRoute roles={["Artist"]}>
              <ArtistBookings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/artist/reports"
          element={
            <ProtectedRoute roles={["Artist"]}>
              <BookingReports />
            </ProtectedRoute>
          }
        />
        <Route
          path="/artist/outsource-persons"
          element={
            <ProtectedRoute roles={["Artist"]}>
              <ArtistOutsourcePersons />
            </ProtectedRoute>
          }
        />
        <Route
          path="/artist/service-prices"
          element={
            <ProtectedRoute roles={["Artist"]}>
              <ServicePricesArtist />
            </ProtectedRoute>
          }
        />
        <Route
          path="/artist/add-booking"
          element={
            <ProtectedRoute roles={["Artist"]}>
              <AddBooking />
            </ProtectedRoute>
          }
        />  
        <Route
          path="/artist/subscription-expired"
          element={
            <ProtectedRoute roles={["Artist"]} requireSubscription={false}>
              <SubscriptionExpired />
            </ProtectedRoute>
          }
        />
        <Route path="/login" element={<LoginRedirect />} />
        <Route path="/register" element={<Register />} />
        <Route path="/signup" element={<ArtistSignup />} />
        <Route path="/signup/plan" element={<PlanSelection />} />
        <Route path="/signup/success" element={<SignupSuccess />} />
        <Route
          path="/auth/force-change-password"
          element={
            <ProtectedRoute>
              <ForceChangePassword />
            </ProtectedRoute>
          }
        />
      </Routes>
    </AuthProvider>
  );
}

export default App;
